export enum Roles {
  admin = 'Administrator',
  staff = 'Staff',

}

export default Roles;  